import { useEffect, useState } from "react";
import { useManageSuppliers } from "../../../hooks/suppliers/useManageSuppliers";
import { SelectField } from "melco-shared-logic";

export type HoopSupplierSelectProps = {
    value: string;
    onChange: (value: string) => void;
}

export const HoopPublishedSupplierSelect: React.FC<HoopSupplierSelectProps> = ({
    value,
    onChange
}) => {
    const { data } = useManageSuppliers("published", "hoops", 99999);

    const [suppliersData, setSuppliersData] = useState<any>();
    useEffect(() => { setSuppliersData(data) }, [data])
    const options = suppliersData?.map((s: any) => ({
        label: s.name,
        value: s.id
    })
    )
    console.log(options)
    return (<>
        {data && <SelectField
            name="supplier_id"
            allowClear
            options={options}
            value={value}
            style={{ "width": "100%", minWidth: "150px" }}
            onChange={(value: string) => { debugger; onChange(value) }}
        />
        }
    </>)
}